export default [
  {
    path: "set",
    name: "activeScreenSet",
    redirect: "/menu/active/:id/screen/:screenid/set/basic",
    component: resolve =>
      require([
        "../views/active/manage/interaction/bigScreenManage/activeset.vue"
      ], resolve),
    children: [
      {
        path: "basic",
        name: "activeScreenBasic",
        component: resolve =>
          require([
            "../views/active/manage/interaction/bigScreenManage/basicSet/basicset.vue"
          ], resolve)
      },
      {
        path: "barrage",
        name: "activeScreenBarrage",
        component: resolve =>
          require([
            "../views/active/manage/interaction/bigScreenManage/basicSet/barrageset.vue"
          ], resolve)
      },
      {
        path: "template",
        name: "activeScreenTemplate",
        component: resolve =>
          require([
            "../views/active/manage/interaction/bigScreenManage/basicSet/templateset.vue"
          ], resolve)
      }
    ]
  },
  {
    path: "content",
    name: "activeScreenContent",
    component: resolve =>
      require([
        "../views/active/manage/interaction/bigScreenManage/content.vue"
      ], resolve)
  },
  {
    path: "userset",
    name: "activeScreenPerson",
    component: resolve =>
      require([
        "../views/active/manage/interaction/bigScreenManage/userset.vue"
      ], resolve)
  },
  {
    path: "lottery",
    name: "activeScreenLottery",
    component: resolve =>
      require([
        "../views/active/manage/interaction/bigScreenManage/lottery.vue"
      ], resolve)
  }
];
